import { Component, forwardRef, OnInit } from '@angular/core';
import { ControlValueAccessor, FormBuilder, FormGroup, NG_VALUE_ACCESSOR } from '@angular/forms';
import * as moment from 'moment';
import { IMyDrpOptions } from 'mydaterangepicker';

@Component({
  selector: 'app-date-range-available-update-so',
  templateUrl: './date-range-available-update-so.component.html',
  styleUrls: ['./date-range-available-update-so.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => DateRangeAvailableUpdateSoComponent),
      multi: true
    }
  ]
})
export class DateRangeAvailableUpdateSoComponent implements OnInit, ControlValueAccessor {

  datePickerRangeForm: FormGroup;
  myDatePickerOptions: IMyDrpOptions = {
    dateFormat: 'mm-dd-yyyy',
    editableDateRangeField: false,
    firstDayOfWeek: 'su',
    markCurrentDay: true,
  };

  onChange: any = () => { };
  onTouch: any = () => { };

  constructor(private fb: FormBuilder) {
    this.initForm();
  }

  ngOnInit() {
    this.datePickerRangeForm.get('dateRange').valueChanges.subscribe((val) => {
      this.onChange(val);
    });
  }

  initForm() {
    this.datePickerRangeForm = this.fb.group({
      dateRange: [null]
    });
  }

  writeValue(value: any): void {
    if (value) {
      this.datePickerRangeForm.get('dateRange').setValue(value);
      this.validDateDay(value.beginDate, value);
    }
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouch = fn;
  }

  setDisabledState?(): void { }

  validDateDay(dateSend, modelDatePicker) {
    let endDay; let mont;
    if (modelDatePicker.beginDate.day === 1) {
      let montRecived;
      dateSend.month === 1 ? montRecived = 12 : montRecived = (dateSend.month - 1);
      const beforeDate = `${dateSend.year}-${montRecived}`;
      endDay = moment(beforeDate, 'YYYY-MM').daysInMonth();
      mont = dateSend.month - 1;
    } else {
      endDay = modelDatePicker.beginDate.day - 1;
      mont = modelDatePicker.beginDate.month;
    }
    this.myDatePickerOptions = {
      disableUntil: {
        year: modelDatePicker.beginDate.year,
        month: mont,
        day: endDay,
      },
      disableSince: {
        year: modelDatePicker.endDate.year,
        month: modelDatePicker.endDate.month,
        day: modelDatePicker.endDate.day + 1,
      },
    };
  }

}



// WEBPACK FOOTER //
// ./src/app/utils/date-range-available-update-so/date-range-available-update-so.component.ts